import { MusicClefTrebleIcon } from './MusicClefTrebleIcon';

/**
 * author: Haley Halcyon
 * id 7ED69559-58ED-432E-800F-9B8DE4CD53A2
 * name music-clef-treble
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-clef-treble.svg
 * tags
 * - Music 
 */
export const MusicGClefIcon = MusicClefTrebleIcon;
export default MusicGClefIcon